<template>
    <v-row class="mt-5" justify="center">
        <v-expansion-panels>
            <v-expansion-panel
            v-for="(debugMethod,i) in debuggingMethods"
            :key="i"
            >
                <v-expansion-panel-header>
                    <template v-slot:default="{ open }">
                        <v-row no-gutters>
                            <v-col cols="2">
                                {{ debugMethod.name }}
                            </v-col>
                            <v-col
                            cols="10"
                            class="text--secondary"
                            >
                            <v-fade-transition leave-absolute>
                                <span v-if="open">
                                {{ debugMethod.description }}
                                </span>
                            </v-fade-transition>
                            </v-col>
                        </v-row>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>

                    <!-- load the component dynamically based on the debugMethod -->
                    <component
                        :is="loadComponent(integration.integration_type.name, debugMethod.method)"
                        :debugMethod="debugMethod"
                        :integration="integration"
                    />

                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-row>
</template>
<script>

import { EventBus } from '@/js/event-bus.js'
import { loadComponent } from './FormMapper';

export default {
    props: {
        integration: { type: Object, required: true },
        is_disabled: { type: Boolean, default: false }
    },

    data() {
        return {
            isLoading: false,
            isRunning: false,
            debuggingMethods: []
        }
    },

    created() {
        this.isLoading = true;
        this.$http
            .get(`/api/debug-tool/${this.$route.params.id}`)
            .then(({ data }) => {
                this.debuggingMethods = data;
            })
            .catch(err => {
                EventBus.$emit('show-error', err);
            })
            .finally(() => {
                this.isLoading = false;
            });
    },

    methods: {
        loadComponent
    },
}
</script>